
import React, { Component } from 'react';

import { connect } from 'react-redux';

import edit from '../../assets/images/Managebooks/edit.svg'

import { createBankDetail, getBankAccount } from '../../store/actions/bankAction';

import LottieAnimation from '../../components/Lottie/lottieAnimation';






var cx = require('classnames');





class BankDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {

            errors: {},
            serverError: {},
            isLoading: false,
            Bank_Name: "",
            Iban: "",
            Account_Title: "",
            ID: "",
            Bank_Detail: [],
            Bank_Type: "Bank"

        };
        this.handleChange = this.handleChange.bind(this);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {


    }


    renderAccount = () => {



        return this.state.Bank_Detail.map((item, i) =>
            <div className="bankinfocontainer mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 ">
                    <div className="row ">
                        <div className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10  ">
                            <p className="mb-0 poppins_regular">{item.Bank_Name}</p>
                            <p className="mb-0 poppins_regular">{item.Iban}</p>
                            <p className="mb-0 poppins_regular">{item.Account_Title}</p>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2  vertical-center">
                            <img className="pointerr" src={edit} onClick={() => this.onClickEdit(item)}></img>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    componentDidMount() {
        this.setState({isLoading:true})
        this.props.getBankAccount().then((res) => {
            console.log(res.content)
            if (res.status == true) {

                this.setState({
                    Bank_Detail: res.content,
                    isLoading:false,

                })

            }
            else {
                alert(res)
            }
        }).catch((err) => {
            console.log(err)

        })

    }
    onClickEdit = (item) => {
        console.log(item)
        var ID = item.ID
        const newBankDetail = this.state.Bank_Detail.map((bank, sidx) => {
            if (bank.ID !== ID) return bank;
            else return {
                ...item, ID: ID
            }
        })
        this.setState({
            Bank_Name: item.Bank_Name,
            Iban: item.Iban,
            Account_Title: item.Account_Title,
            ID: item.ID,
            Bank_Detail: newBankDetail

        })
    }
    togglecongratulationModal = () => {
        this.setState({ CongratulationModal: !this.state.CongratulationModal })
    }




    handlecongratulationClosemodal = (e) => {
        this.setState({ CongratulationModal: !this.state.CongratulationModal })

    }
    handleChange(event) {
        if (event.target.value == 1) {
            this.setState({ CongratulationModal: !this.state.CongratulationModal })
        }


    }


    onChange = (e) => {
        if (e.target.value === "EasyPaisa") {
            this.setState({ [e.target.name]: e.target.value, Bank_Name: "Telenor Microfinance Bank" })
        }
        this.setState({ [e.target.name]: e.target.value })

    }

    onCreateBankDetail = () => {
        this.setState({ errors: {}, serverError: {}, isLoading: true })
        var bankData = {
            "Bank_Name": this.state.Bank_Name,
            "Iban": this.state.Iban,
            "Account_Title": this.state.Account_Title,
            "ID": this.state.ID,

        }
        this.props.createBankDetail(bankData).then((res) => {
            //console.log(res)

            if (res.status) {
                let arr = this.state.Bank_Detail
                arr.push(bankData)
                //console.log(res.content)
                this.setState({
                   // Bank_Detail: arr,
                    Bank_Name: '',
                    Iban: '',
                    Account_Title: '',
                    ID: '',
                    isLoading: false,

                }, () => console.log(this.state.Bank_Detail))
                // this.props.history.push('/menu/menugrid');
            }

        }).catch((err) => {
            var validationError = {}
            var serverError = []
            this.setState({ isLoading: false, })
            if (err.hasOwnProperty('validation')) {
                err.validation.map(obj => {
                    if (obj.hasOwnProperty('param')) {
                        validationError[obj["param"]] = obj["msg"]
                    } else {
                        serverError = [...serverError, obj]
                    }
                });
                this.setState({ errors: validationError });
                this.setState({ serverError: serverError });
            } else {
                this.setState({ serverError: [{ "msg": "server not responding" }] })
            }
        })
    }

    render() {

        const { isLoading } = this.state;
        if (isLoading) {
            return (
               <LottieAnimation/>
            )
        }

        // if (isLoading) {
        //     return (
        //         <div className="loader-large"></div>
        //     )
        // }

        return (
            <div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 managebookContainer">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                                <p className="poppins_semibold managebookheading">Add Bank Details</p>
                            </div>
                            {isLoading &&

                                <div className="loader-large"></div>
                            }
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  mt-3">
                                        <p className="heading_bank">Bank Information</p>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                                            <div className="bankinfocontainer">
                                                <p className="poppins_regular bankinfoinputlabel" >Payment Mode / Type</p>
                                                <select className="bankinfoInput" name="Bank_Type" onChange={this.onChange} value={this.state.Bank_Type}>

                                                    <option value="Bank">Bank</option>
                                                    <option value="EasyPaisa">Easy Paisa</option>

                                                </select>
                                                {this.state.Bank_Type == "Bank" &&
                                                    <>
                                                        <p className="poppins_regular bankinfoinputlabel" >Bank Name</p>
                                                        <input className="bankinfoInput" name="Bank_Name" onChange={this.onChange} value={this.state.Bank_Name}></input>
                                                        <p className="poppins_regular bankinfoinputlabel" >Bank Account Number / IBAN</p>
                                                        <input className="bankinfoInput" name="Iban" onChange={this.onChange} value={this.state.Iban}></input>
                                                        <p className="poppins_regular bankinfoinputlabel" >Account Title</p>
                                                        <input className="bankinfoInput" name="Account_Title" onChange={this.onChange} value={this.state.Account_Title}></input>
                                                        <div className="text-center mt-5">

                                                            <button className="poppins_bold saveinfobtn" disabled={this.state.Bank_Name === "" || this.state.Iban === "" || this.state.Account_Title === ""} onClick={this.onCreateBankDetail}>Save info</button>
                                                        </div>
                                                    </>
                                                }
                                                {this.state.Bank_Type == "EasyPaisa" &&
                                                    <>

                                                        <p className="poppins_regular bankinfoinputlabel" >Bank Name</p>
                                                        <input className="bankinfoInput" name="Bank_Name" onChange={this.onChange} value={this.state.Bank_Name} disabled="true" ></input>
                                                        <p className="poppins_regular bankinfoinputlabel" >Bank Account Number / IBAN</p>
                                                        <input className="bankinfoInput" name="Iban" onChange={this.onChange} value={this.state.Iban}></input>
                                                        <p className="poppins_regular bankinfoinputlabel" >Account Title</p>
                                                        <input className="bankinfoInput" name="Account_Title" onChange={this.onChange} value={this.state.Account_Title}></input>
                                                        <div className="text-center mt-5">

                                                            <button className="poppins_bold saveinfobtn" disabled={this.state.Iban === "" || this.state.Account_Title === ""} onClick={this.onCreateBankDetail}>Save info</button>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>


                                    </div>
                                    {this.state.Bank_Detail && this.state.Bank_Detail.length !== 0 && (
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-3 ">
                                            <p className="heading_bank">Bank Details</p>
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">

                                               {this.renderAccount()}

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>





                        </div>


                    </div>


                </div>




            </div>

        )
    }

}

BankDetails.propTypes = {

};


const mapStateToProps = state => ({
    auth: state.auth
});

const mapDispatchToProps = ({
    createBankDetail,
    getBankAccount,

})
export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
